module.exports = __webpack_public_path__ + "citrus-segment-sideways.png?4281619f17d2084c9d4ee488c3dfebc6";


//////////////////
// WEBPACK FOOTER
// ./static/citrus-segment-sideways.png
// module id = 529
// module chunks = 0